import React from 'react'
import { useSelector } from 'react-redux'

import Avatar from 'components/common/Avatar'
import { _user } from 'store/selectors/User'

import useVideoEnable from './hooks/useVideoEnable'
import { ParticipantContainer, VideoContainer, VideoView } from './styles'

const Tile = props => {
    const { type: userType, userInfo } = useSelector(_user)
    const [videoRef, isVideoEnable] = useVideoEnable()
    return (
        <ParticipantContainer checkPassed={props.checkPassed}>
            <VideoContainer showBgColor={!isVideoEnable}>
                {isVideoEnable ? (
                    <VideoView
                        ref={videoRef}
                        autoPlay
                        playsInline
                        muted
                        webkit-playsinline="true"
                    />
                ) : (
                    <Avatar uuid={userInfo.user_id} userType={userType} />
                )}
            </VideoContainer>
        </ParticipantContainer>
    )
}

export default Tile
